import { render, staticRenderFns } from "./DetectLang.vue?vue&type=template&id=f76d011e&"
import script from "./DetectLang.vue?vue&type=script&lang=ts&"
export * from "./DetectLang.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports